import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CircleDashed } from 'lucide-react';
export const Nav: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-surface/90 backdrop-blur-md border-b border-primary/10 py-4' : 'bg-transparent py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-328">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-329">
        <div className="flex items-center gap-2 text-primary" data-id="element-330">
          <CircleDashed className="w-6 h-6 animate-spin-slow text-leaf" data-id="element-331" />
          <span className="font-display font-semibold text-2xl tracking-tight" data-id="element-332">
            CycleBox
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-ink/80" data-id="element-333">
          <a href="#how-it-works" className="hover:text-primary transition-colors" data-id="element-334">
            How it works
          </a>
          <a href="#technology" className="hover:text-primary transition-colors" data-id="element-335">
            Technology
          </a>
          <a href="#impact" className="hover:text-primary transition-colors" data-id="element-336">
            Impact
          </a>
          <a href="#pricing" className="hover:text-primary transition-colors" data-id="element-337">
            Pricing
          </a>
        </nav>

        <div className="flex items-center gap-4" data-id="element-338">
          <Button variant="primary" size="sm" className="hidden md:inline-flex" data-id="element-339">
            Request a demo
          </Button>
        </div>
      </div>
    </motion.header>;
};